/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type NavbarDropdown_user$ref = any;
type SearchBarNav_user$ref = any;
type ShopWithCeoDialog_user$ref = any;
export type NavbarComponent_user$ref = any;
export type NavbarComponent_user = {
    readonly id: string;
    readonly publicId: string | null;
    readonly userId: string | null;
    readonly role: string | null;
    readonly email: string | null;
    readonly firstName: string | null;
    readonly profile: ({
        readonly id: string;
        readonly image: string | null;
    }) | null;
    readonly permissions: ({
        readonly id: string;
        readonly oneCommerce: ({
            readonly id: string;
            readonly ceo: ({
                readonly access: boolean | null;
            }) | null;
            readonly preferredCustomer: ({
                readonly access: boolean | null;
            }) | null;
        }) | null;
    }) | null;
    readonly preferredCustomerCeoAccountId: string | null;
    readonly shoppingWithCeoUser: ({
        readonly id: string;
        readonly publicId: string | null;
        readonly userId: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly profile: ({
            readonly id: string;
            readonly image: string | null;
        }) | null;
    }) | null;
    readonly conciergeUser: ({
        readonly id: string;
        readonly userId: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly organizationName: string | null;
    }) | null;
    readonly accountRole: ({
        readonly accountRoleTitle: string | null;
    }) | null;
    readonly cartV2: ({
        readonly id: string;
        readonly totalNumberOfItems: number | null;
        readonly eventId: string | null;
        readonly eventHostFirstName: string | null;
        readonly event: ({
            readonly id: string;
            readonly hostAccountId: string | null;
            readonly accountId: string | null;
        }) | null;
    }) | null;
    readonly " $fragmentRefs": SearchBarNav_user$ref & ShopWithCeoDialog_user$ref & NavbarDropdown_user$ref;
    readonly " $refType": NavbarComponent_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "publicId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "profile",
        "storageKey": null,
        "args": null,
        "concreteType": "Profile",
        "plural": false,
        "selections": [
            (v1 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "image",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v5 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "NavbarComponent_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "FragmentSpread",
                "name": "SearchBarNav_user",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "NavbarDropdown_user",
                "args": null
            },
            (v1 /*: any*/),
            (v2 /*: any*/),
            (v3 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "role",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ShopWithCeoDialog_user",
                "args": null
            },
            (v4 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "permissions",
                "storageKey": null,
                "args": null,
                "concreteType": "PermissionsType",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "oneCommerce",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OneCommerceType",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "ceo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AccessType",
                                "plural": false,
                                "selections": (v5 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "preferredCustomer",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AccessType",
                                "plural": false,
                                "selections": (v5 /*: any*/)
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "preferredCustomerCeoAccountId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "shoppingWithCeoUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    (v2 /*: any*/),
                    (v3 /*: any*/),
                    (v0 /*: any*/),
                    (v6 /*: any*/),
                    (v4 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "conciergeUser",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    (v3 /*: any*/),
                    (v0 /*: any*/),
                    (v6 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "organizationName",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "accountRole",
                "storageKey": null,
                "args": null,
                "concreteType": "AccountRoleType",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "accountRoleTitle",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "cartV2",
                "storageKey": null,
                "args": null,
                "concreteType": "CartV2",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalNumberOfItems",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventHostFirstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hostAccountId",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "accountId",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '56da3e88947b227b480f607ba131a243';
export default node;
